import { RULE_ERROR_CODE } from './basic'
import type { RuleErrorItem } from './basic'
import type { CustomEdgeType } from 'src/newComponents/edges/customEdge'
import type { CustomNodeType } from 'src/newComponents/nodes/types'
// import type { CustomEdgeType } from '../newComponents/edges/customEdge'
// import type { CustomNode } from '../newComponents/nodes/types'

export interface ErrorStatus {
  hasErr: boolean
  errIdList: {
    errInfo: RuleErrorItem
    id: string
    type: string
  }[]
}

export function checkAll(nodes: CustomNodeType[], edges: CustomEdgeType[]): ErrorStatus {
  const sameNameStatus = checkSameName(nodes)
  if (sameNameStatus.hasErr) {
    return sameNameStatus
  }
  const treeStatus = checkRing(nodes, edges)
  if (treeStatus.hasErr) {
    return treeStatus
  }
  return {
    hasErr: false,
    errIdList: [],
  }
}

export function checkSameName(nodes: CustomNodeType[]) {
  const nameMap = new Map()
  const errIdMap: Map<string, string> = new Map()
  for (let i = 0; i < nodes.length; i++) {
    const name = nodes[i].data.nodeName
    const status = nameMap.has(name)
    if (status) {
      errIdMap.set(nodes[i].id, 'node')
      errIdMap.set(nameMap.get(nodes[i].data.nodeName), 'node')
    }
    nameMap.set(name, nodes[i].id)
  }
  // for (let j = 0; j < edges.length; j++) {
  //   const name
  //     = edges[j].data!.edgeName && edges[j].data!.edgeName !== ''
  //       ? edges[j].data!.edgeName
  //       : null
  //   if (!name) {
  //     continue
  //   }
  //   const status = nameMap.has(name)
  //   if (status) {
  //     errIdMap.set(edges[j].id, 'edge')
  //     errIdMap.set(nameMap.get(edges[j].data!.edgeName), 'edge')
  //   }
  //   nameMap.set(name, edges[j].id)
  // }
  const arrFromErrIdMap = Array.from(errIdMap)
  console.log(arrFromErrIdMap)
  const errIdList: Array<{
    errInfo: RuleErrorItem
    id: string
    type: string
  }> = arrFromErrIdMap.map((value) => {
    return {
      id: value[0],
      type: value[1],
      errInfo: RULE_ERROR_CODE.SAME_NAME,
    }
  })
  return {
    hasErr: errIdList.length > 0,
    errIdList,
  }
}

// export const checkEdge = (edges: CustomEdge[]) => {};

export function checkRing(nodes: CustomNodeType[], edges: CustomEdgeType[]) {
  let hasRingStatus = false
  let errIdList: Array<{
    errInfo: RuleErrorItem
    id: string
    type: string
  }> = []
  let isNotLinkOutput = false
  let isDiscreteNode = false
  let isUnclosed = false

  function dfs(node: CustomNodeType, arr: string[]) {
    const index = arr.findIndex(id => id === node.id)
    if (index !== -1) {
      hasRingStatus = true
      errIdList = errIdList.concat(
        arr.slice(index, arr.length).map((id) => {
          return {
            errInfo: RULE_ERROR_CODE.RING,
            type: 'node',
            id,
          }
        }),
      )
      return
    }
    if (!hasRingStatus && !isNotLinkOutput) {
      const newArr = arr.concat(node.id)
      const linkEdges = edges.filter(edge => edge.source === node.id)
      const targetNode = linkEdges.map(
        edge => nodes.find(node => node.id === edge.target)!,
      )
      if (targetNode.length === 0 && node.data.nodeType !== 'output') {
        isNotLinkOutput = true
        errIdList = errIdList.concat({
          errInfo: RULE_ERROR_CODE.NOT_LINK_OUTPUT,
          type: 'node',
          id: node.id,
        })
        return
      }
      targetNode.forEach((node) => {
        dfs(node, newArr)
      })
    }
  }

  const startNode = nodes.find(node => node.data.nodeType === 'input')!
  const idArr: string[] = []
  for (let i = 0; i < nodes.length; i++) {
    if (nodes[i].data.nodeType === 'input') {
      if (!edges.find(edge => edge.source === nodes[i].id)) {
        isDiscreteNode = true
        errIdList.push({
          errInfo: RULE_ERROR_CODE.DISCRETE,
          type: 'node',
          id: nodes[i].id,
        })
        continue
      }
    }
    else if (nodes[i].data.nodeType === 'output') {
      if (!edges.find(edge => edge.target === nodes[i].id)) {
        isDiscreteNode = true
        errIdList.push({
          errInfo: RULE_ERROR_CODE.DISCRETE,
          type: 'node',
          id: nodes[i].id,
        })
        continue
      }
    }
    else {
      if (
        !edges.find(edge => edge.source === nodes[i].id)
        && !edges.find(edge => edge.target === nodes[i].id)
      ) {
        isDiscreteNode = true
        errIdList.push({
          errInfo: RULE_ERROR_CODE.DISCRETE,
          type: 'node',
          id: nodes[i].id,
        })
        continue
      }

      if (
        !edges.find(edge => edge.source === nodes[i].id)
        || !edges.find(edge => edge.target === nodes[i].id)
      ) {
        isUnclosed = true
        errIdList.push({
          errInfo: RULE_ERROR_CODE.UNCLOSE,
          type: 'node',
          id: nodes[i].id,
        })
        continue
      }
    }
  }
  dfs(startNode, idArr)
  const hasErr = hasRingStatus || isNotLinkOutput || isDiscreteNode || isUnclosed
  return {
    hasErr,
    errIdList,
  }
}
